import { getParentIdentifier } from 'apps/web_forms/components/Form/utils';
import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

function useRules(element, formContext = {}) {
  const {
    identifier,
    required_rule: requiredRule,
    readonly_rule: readonlyRule,
  } = element;

  const { getValues, formState } = formContext;

  let virtualValue = getValues(identifier) !== undefined ? getValues(identifier) : undefined;

  const currentStoredRules = useSelector((state) => state.form.rules[identifier]);
  const parentStoredRules = useSelector((state) => {
    const rules = {};
    let currentIdentifier = identifier;

    while (currentIdentifier?.includes('/')) {
      currentIdentifier = getParentIdentifier(currentIdentifier);
      if (state.form.rules[currentIdentifier]) {
        rules[currentIdentifier] = state.form.rules[currentIdentifier];
      }
    }

    return rules;
  }, shallowEqual);
  const currentInitialAnswers = useSelector((state) => state.form.initialAnswers[identifier]);
  const currentDraftAnswer = useSelector((state) => state.form.draftAnswers[identifier]);

  const isActive = useMemo(() => {
    if (someParentIsInactive(identifier, parentStoredRules)) return false;

    return (
      !currentStoredRules ||
      currentStoredRules.visible_expr ||
      !('visible_expr' in currentStoredRules)
    );
  }, [identifier, parentStoredRules, currentStoredRules]);

  const alwaysRequired = requiredRule === 'always';
  const alwaysReadOnly = readonlyRule === 'always';

  return [
    {
      isActive,
      isElementValid:
        !isActive ||
        !currentStoredRules ||
        currentStoredRules.validate_expr ||
        !('validate_expr' in currentStoredRules),
      isRequired:
        isActive && (alwaysRequired || currentStoredRules?.required_expr),
      isReadOnly:
        isActive && (alwaysReadOnly || currentStoredRules?.readonly_expr),
      calculatedResult: isActive ? currentStoredRules?.calculate_expr : '',
      initialAnswer: getInitialAnswer(
        element.initialAnswerExpr,
        element.initialAnswer,
        currentInitialAnswers,
        currentDraftAnswer,
        virtualValue,
        formState?.dirtyFields[identifier],
      ),

      selectOptionFilters: currentStoredRules?.selectOptionFilters,
    },
  ];

}

function getInitialAnswer(
  elementInitialExpr,
  elementInitialAnswer,
  currentInitialAnswers,
  currentDraftAnswer,
  virtualValue,
  isDirty
) {
  if(virtualValue !== undefined && isDirty){
    return virtualValue;
  }
  if (currentDraftAnswer) {
    return currentDraftAnswer;
  }
  return elementInitialExpr ? currentInitialAnswers : elementInitialAnswer;
}

function someParentIsInactive(childIdentifier, allStoredRules) {
  if (!childIdentifier) return null;

  let currentIdentifier;
  if (childIdentifier.includes('/')) {
    currentIdentifier = getParentIdentifier(childIdentifier);
  } else {
    return false;
  }

  if (allStoredRules[currentIdentifier]?.visible_expr === false) {
    return true;
  }

  return someParentIsInactive(currentIdentifier, allStoredRules);
}
export default useRules;
